import { postToHygraph } from './common';

const getPressList = async (preview) => {
  const query = /* GraphQL */ `
    query PressQuery {
      presses(first: 10) {
        title
        logo {
          fileName
          url
        }
        url
        publication
        description
        size
        image {
          fileName
          url
        }
      }
    }
  `;
  return await postToHygraph(query, undefined, preview);
};

export { getPressList };
